import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, auth } from "@/lib/api";
import Navbar from "@/components/Navbar";
import { Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [creds, setCreds] = useState({ username: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await api.post("/admin/login", creds);
      auth.setSession(r.data.token, "admin", { name: "Admin" });
      toast.success("Welcome, Admin");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar variant="dashboard" />
      <div className="max-w-md mx-auto px-6 py-20 fade-in">
        <div className="text-xs uppercase tracking-widest text-[#1E3F20] font-semibold">
          Admin
        </div>
        <h1 className="font-display text-4xl mt-2">Admin Login</h1>
        <p className="text-[#4A4A4A] mt-2">Default: admin / admin123</p>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <div>
            <label className="text-sm font-medium">Username</label>
            <input
              className="octa-input mt-2"
              value={creds.username}
              onChange={(e) => setCreds({ ...creds, username: e.target.value })}
              data-testid="admin-username-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium">Password</label>
            <div className="relative mt-2">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#737373]" />
              <input
                type="password"
                className="octa-input pl-11"
                value={creds.password}
                onChange={(e) => setCreds({ ...creds, password: e.target.value })}
                data-testid="admin-password-input"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full h-12 rounded-full btn-primary-octa font-semibold disabled:opacity-50"
            data-testid="admin-login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
